import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { createElement, FC } from 'react';

import { File, Issue, IssueComment, Maybe, Request, RequestItem, User } from '../../../../../graphql/generated/graphql';
import { SPACING_REGULAR } from '../../../../constant/spacing';
import ModificationRequestItem from './ModificationRequestItem';

interface Props {
  creativeFile: Pick<File, 'mimeType' | 'url'>;
  hasSubmittedDeliverable: boolean;
  modificationRequest: Pick<Request, 'state' | 'bucketId'> & {
    items: (Pick<RequestItem, 'id' | 'typeName' | 'metadata' | 'sender' | 'assetIds' | 'body'> & {
      issue?: Maybe<
        Pick<Issue, 'id' | 'resolved'> & {
          comments: (Pick<IssueComment, 'assetIds' | 'body' | 'createdAt'> & {
            user: Pick<User, 'name' | 'profileImageUrl'>;
          })[];
        }
      >;
    })[];
  };
  assets: Array<FileReference>;
  onRequestCreateModificationRequestIssue: (id: string, body: string) => void;
  onRequestCreateModificationRequestItemIssueComment: (
    id: string,
    body: string,
    bucketId: string,
    assetIds: string[],
  ) => void;
  onRequestResolveModificationRequestIssue: (id: string) => void;
  onRequestReopenModificationRequestIssue: (id: string) => void;
  className?: string;
}

const ModificationRequestDetail: FC<Props> = ({
  creativeFile,
  hasSubmittedDeliverable,
  modificationRequest,
  assets,
  onRequestCreateModificationRequestIssue,
  onRequestCreateModificationRequestItemIssueComment,
  onRequestResolveModificationRequestIssue,
  onRequestReopenModificationRequestIssue,
  className,
}) => {
  const items = modificationRequest.items.map((item, i) => (
    <Item
      creativeFile={creativeFile}
      hasSubmittedDeliverable={hasSubmittedDeliverable}
      modificationRequestState={modificationRequest.state}
      bucketId={modificationRequest.bucketId || ''}
      assets={assets}
      onRequestCreateModificationRequestIssue={onRequestCreateModificationRequestIssue}
      onRequestCreateModificationRequestItemIssueComment={onRequestCreateModificationRequestItemIssueComment}
      onRequestResolveModificationRequestIssue={onRequestResolveModificationRequestIssue}
      onRequestReopenModificationRequestIssue={onRequestReopenModificationRequestIssue}
      item={item}
      index={i}
      key={`modificationRequestItem=${i}`}
    />
  ));

  return <div className={className}>{items}</div>;
};

const Item = styled(ModificationRequestItem)({
  marginBottom: SPACING_REGULAR,
  ':last-child': {
    marginBottom: 0,
  },
});

export default ModificationRequestDetail;
